import React, { createContext, useState, } from "react";


export const EmployeeSkillsContext = createContext();

export const EmployeeSkillsProvider = ({ children }) => {

    const [isDrawerOpen, setIsDrawerOpen] = useState(false);

    const [reloadRoles, setReloadRoles] = useState(false);
    const [waitingforResponse, setWaitingforResponse] = useState(false);
    const [llmresponse, setLlmresponse] = useState();

    const toggleDrawer = () => {
        setIsDrawerOpen(!isDrawerOpen);
    };

    return (
        <EmployeeSkillsContext.Provider
            value={{
                isDrawerOpen,
                setIsDrawerOpen,
                toggleDrawer,
                reloadRoles,
                setReloadRoles,
                waitingforResponse,
                setWaitingforResponse,
                llmresponse,
                setLlmresponse,
            }}
        >
            {children}
        </EmployeeSkillsContext.Provider>
    );
};
